// components/ActionButtons.js
import React from 'react';
import { Printer, Download } from 'lucide-react';

const ActionButtons = ({ onPrint, onDownload }) => {
  return (
    <div className="flex gap-3 mt-6">
      <button
        onClick={onPrint}
        className="flex-1 bg-blue-300 text-blue-800 font-medium py-2 px-4 rounded-md hover:bg-blue-400 flex items-center justify-center transition-colors"
      >
        <Printer className="w-4 h-4 mr-2" />
        인쇄
      </button>
      <button
        onClick={onDownload}
        className="flex-1 bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 flex items-center justify-center transition-colors"
      >
        <Download className="w-4 h-4 mr-2" />
        다운로드
      </button>
    </div>
  );
};

export default ActionButtons;